import React from "react";
import styled from "styled-components";
import { withPage } from "../../Page";
import AppConfig from "../../Config";
import BannersCarousel from "../../Components/BannersCarousel";
import HecafePromotionSection from "../../Components/HecafePromotionSection";
import HotSaleSection from "../../Components/HotSaleSection";
import NewStoreSection from "../../Components/NewStoreSection";
import StroresCarouselSection from "../../Components/StoresCarouselSection";
import HecafeBlogSection from "../../Components/HecafeBlogSection";
import FindFlavorSection from "../../Components/FindFlavorSection";
import AboutUsScreen from "../../Components/AboutUsSection";
import CooperationSection from "../../Components/CooperationSection";
import ChattyButton from "../../../chatty/Components/ChattyButton";

class HomePage extends React.Component {
  render() {
    let config = AppConfig["Templates/LandingPage"];
    let { banners } = this.props.pageContext.initialState.content;
    let { blogs } = this.props.pageContext.initialState.content;

    return (
      <Wrapper>
        <div className="banner" style={{ marginBottom: 55 }}>
          <BannersCarousel banners={banners} />
        </div>

        <div className="section" style={{ marginBottom: 50 }}>
          <HecafePromotionSection />
        </div>

        <div className="section" style={{ marginBottom: 60 }}>
          <HotSaleSection />
        </div>

        <div className="section" style={{ marginBottom: 70 }}>
          <NewStoreSection />
        </div>

        <div className="section" style={{ marginBottom: 60 }}>
          <StroresCarouselSection />
        </div>

        <div className="section" style={{ marginBottom: 50 }}>
          <HecafeBlogSection content={blogs} />
        </div>

        <div className="section" style={{ marginBottom: 70 }}>
          <FindFlavorSection />
        </div>

        <div className="section">
          <AboutUsScreen />
        </div>

        <div className="section">
          <CooperationSection />
        </div>

        <ChattyButton />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  position: relative;

  & > .banner {
    margin-top: 70px;
  }

  & > .section {
  }

  & > .bg-color-section {
    width: 100%;
    background-color: #f5f5f5;
  }

  ${AppConfig["Templates/LandingPage"].css || ""};
`;

export default withPage(HomePage);
